// import Bibliographies from './Bibliographies';
import { connect } from 'react-redux';
import { reset } from 'redux-form';

import addAbilityToOpenModal from '../../../utilities/modalHOC';
import { updateSelectedCycleAction } from '../../Cycles/actions';
import { loadArchivedCycles, loadCycles } from '../../Cycles/actionsSagas';
import { getCycles, getSelectedCycle } from '../../Cycles/selectors';
import {
  getGeneralRolesPermissions,
  getRolesPermissions,
  getUser,
} from '../../Login/selectors';
import { updateRate } from '../../Rates/actions';
import { createRate, loadRates, loadTopics } from '../../Rates/actionsSagas';
import {
  getLinks,
  getPagination,
  getRate,
  getRates,
  getTopics,
  getTopicsInmutable,
  getWaiting,
} from '../../Rates/selectors';
import {
  getDutyStateReferences,
  getRankReferences,
} from '../../References/selectors';
import {
  examReceivedAction,
  setActualState,
  setIsRevertChecked,
  setIsUndoChecked,
  setRateBibliographyJson,
  setRateChapterQuestionsReport,
  setRatingExamQuestions,
  setUndoState,
  updateCheckedReferences,
  updateCheckedSubtopics,
  updateCycleAction,
  updateDutyState,
  updateDutyStates,
  updateRank,
  updateRanks,
  updateSelectedListTab,
  updateSelectedTab,
} from '../actions';
import {
  createChapterActionSagas,
  createReferenceActionSagas,
  getRateRatingExamQuestions,
  loadExam,
  loadRateBibliographyJson,
  loadRateChapterQuestionsReport,
  loadReferences,
  submitBibliographyActionSagas,
} from '../actionsSagas';
import {
  getActiveListTab,
  getActiveTab,
  getActualState,
  getBibliographyJson,
  getCheckedReferences,
  getCheckedSubtopics,
  getCycle,
  getDutyState,
  getDutyStates,
  getIsRevertChecked,
  getIsUndoChecked,
  getOriginalCheckedReferences,
  getOriginalCheckedSubtopics,
  getRank,
  getRanks,
  getRateChapterQuestionsReport,
  getRatingExamQuestions,
  getReferences,
  getReferencesImmutable,
  getUndoState,
  loadingExam,
  loadingGrid,
} from '../selectors';
import NewBibliographies from './NewBibliographies';

const mapStateToProps = (state) => ({
  rates: getRates(state),
  topics: getTopics(state),
  topicsImmutable: getTopicsInmutable(state),
  references: getReferences(state),
  referencesImmutable: getReferencesImmutable(state),
  checkedSubtopics: getCheckedSubtopics(state),
  checkedReferences: getCheckedReferences(state),
  dutyState: getDutyState(state),
  rank: getRank(state),
  cycles: getCycles(state),
  loadingExam: loadingExam(state),
  loadingGrid: loadingGrid(state),
  cycle: getCycle(state),
  isUndoChecked: getIsUndoChecked(state),
  isRevertChecked: getIsRevertChecked(state),
  waiting: getWaiting(state),
  ratesPagination: getPagination(state),
  rate: getRate(state),
  generalRolesPermissions: getGeneralRolesPermissions(state),
  rolesPermissions: getRolesPermissions(state),
  links: getLinks(state),
  user: getUser(state),
  ranks: getRanks(state),
  dutyStates: getDutyStates(state),
  rankReferences: getRankReferences(state),
  dutyStateReferences: getDutyStateReferences(state),
  activeTab: getActiveTab(state),
  activeListTab: getActiveListTab(state),
  selectedCycle: getSelectedCycle(state),
  originalCheckedSubtopics: getOriginalCheckedSubtopics(state),
  originalCheckedReferences: getOriginalCheckedReferences(state),
  ratingExamQuestions: getRatingExamQuestions(state),
  bibliographyJson: getBibliographyJson(state),
  rateChapterQuestionsReport: getRateChapterQuestionsReport(state),
  getUndoState: getUndoState(state),
  getActualState: getActualState(state),
});

const mapDispatchToProps = (dispatch) => ({
  setUndoState: (undoState) => dispatch(setUndoState(undoState)),
  setActualState: (actualState) => dispatch(setActualState(actualState)),
  setIsUndoChecked: (undoChecked) => dispatch(setIsUndoChecked(undoChecked)),
  setIsRevertChecked: (revertChecked) =>
    dispatch(setIsRevertChecked(revertChecked)),
  loadRates: () => dispatch(loadRates(null, true)),
  loadTopics: (exam) => dispatch(loadTopics(exam, 'Bibliographies')),
  loadReferences: (id, type) => dispatch(loadReferences(id, type)),
  updateCheckedSubtopics: (subtopics) =>
    dispatch(updateCheckedSubtopics(subtopics)),
  updateCheckedReferences: (references) =>
    dispatch(updateCheckedReferences(references)),
  updateCycle: (cycle) => dispatch(updateCycleAction(cycle)),
  createReference: (fields, rate) => {
    dispatch(createReferenceActionSagas(fields, rate, 'rate'));
  },
  createChapter: (fields) => {
    dispatch(createChapterActionSagas(fields));
  },
  updateDutyState: (dutyState) => dispatch(updateDutyState(dutyState)),
  updateRank: (rating) => dispatch(updateRank(rating)),
  submitBibliography: (bibliography) =>
    dispatch(submitBibliographyActionSagas(bibliography)),
  loadCycles: () => dispatch(loadCycles()),
  loadExam: (dutyState, rank, rate, cycle) =>
    dispatch(loadExam(dutyState, rank, rate, cycle)),
  createRate: (fields) => dispatch(createRate(fields)),
  updateRate: (rate) => dispatch(updateRate(rate)),
  updateRanks: (ranks) => dispatch(updateRanks(ranks)),
  updateDutyStates: (dutyStates) => dispatch(updateDutyStates(dutyStates)),
  loadExamNoCycle: () =>
    dispatch(examReceivedAction({ subtopics: [], chapters: [] })),
  onUpdateSelectedTab: (tab) => dispatch(updateSelectedTab(tab)),
  onUpdateSelectedListTab: (tab) => dispatch(updateSelectedListTab(tab)),
  updateSelectedCycle: (cycle) => {
    dispatch(reset('CycleForm'));
    dispatch(updateSelectedCycleAction(cycle));
  },
  loadArchivedCycles: () => {
    dispatch(loadArchivedCycles());
  },
  getRateRatingExamQuestions: (rate, rank, dutyState, cycle) => {
    dispatch(getRateRatingExamQuestions(rate, false, cycle));
  },
  setRatingExamQuestions: (ratingExamQuestion) => {
    dispatch(setRatingExamQuestions(ratingExamQuestion));
  },
  loadRateBibliographyJson: (rateId) => {
    dispatch(loadRateBibliographyJson(rateId));
  },
  loadRateChapterQuestionsReport: (rateId) => {
    dispatch(loadRateChapterQuestionsReport(rateId));
  },
  clearBibJson: () => {
    dispatch(setRateChapterQuestionsReport());
    dispatch(setRateBibliographyJson());
  },
});

export default addAbilityToOpenModal(
  connect(mapStateToProps, mapDispatchToProps)(NewBibliographies),
);
